import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Label } from 'semantic-ui-react';

import { REPORT_TYPE, SEGMENT_BY } from '@constants/common/chart/chartConst';
import RadioButtons from '@lib/inputs/RadioButtons';
import { SegmentByContainer } from './styles';

function SegmentBy(props: {
    selectedReport: string;
    segmentBy: string;
    setSegmentBy: Function;
    isDrillDownActive: boolean;
    showAssigneeSegment?: boolean;
    isTagFilterApplied: boolean;
}) {
    const {
        selectedReport,
        segmentBy,
        setSegmentBy,
        isDrillDownActive,
        showAssigneeSegment = false,
        isTagFilterApplied,
    } = props;
    const firstOption =
        selectedReport === REPORT_TYPE.UPCOMING_DUE_DATES ? SEGMENT_BY.TAB_STATUS : SEGMENT_BY.WORKGROUP;
    const secondOption =
        selectedReport === REPORT_TYPE.UPCOMING_DUE_DATES ? SEGMENT_BY.TAB_DUE_DATE : SEGMENT_BY.ASSIGNEE;

    const getOptions = useMemo(() => {
        return [
            {
                id: 1,
                value: firstOption,
                text: firstOption,
            },
            {
                id: 2,
                value: secondOption,
                text: secondOption,
            },
        ];
    }, []);

    const isDisabled = useMemo(
        () => isDrillDownActive || (selectedReport !== REPORT_TYPE.UPCOMING_DUE_DATES && !isTagFilterApplied),
        [isDrillDownActive, selectedReport, isTagFilterApplied],
    );
    return (
        <SegmentByContainer className="--segment-by">
            <Label htmlFor="segmentBy">
                <FormattedMessage
                    id={
                        selectedReport === REPORT_TYPE.UPCOMING_DUE_DATES
                            ? 'reports.label.segmentBy'
                            : 'reports.label.showBy'
                    }
                />
            </Label>
            <RadioButtons
                label={{
                    showRequiredIcon: false,

                    labelClass: [''],
                    ulClass: [''],
                    isLabelVisible: false,
                }}
                inputData={{
                    id: 'segmentBy',
                    isInputRequired: true,
                    type: 'radio',
                    options: getOptions,
                    value: segmentBy,
                    disabled: isDisabled,
                    liClass: ['text-left'],
                }}
                legend={{
                    dataInstructions: false,
                }}
                inputActions={{
                    handleFieldChange: value => setSegmentBy(value),
                }}
            />
        </SegmentByContainer>
    );
}

export default SegmentBy;
